'use client'

import { createContext, useEffect, useState } from 'react'
import { safeGetItem, safeSetItem } from '../helpers/safeStorage'
import {
  CHARACTER_SEXUALITIES,
  CHARACTER_SORTS,
  CHARACTER_STYLES,
  remembered,
} from '../lib/character-feed'

export const ChatImageContext = createContext('')

export const ChatImageProvider = ({ children }) => {
  const [topImages, setTopImages] = useState({
    all: { all: [], woman: [], man: [] },
    Hyperreal: { all: [], woman: [], man: [] },
    Anime: { all: [], woman: [], man: [] },
    Hyperanime: { all: [], woman: [], man: [] },
    Real: { all: [], woman: [], man: [] },
    'K-Pop': { all: [], woman: [], man: [] },
    Fur: { all: [], woman: [], man: [] },
  })

  const [featuredImages, setFeaturedImages] = useState({
    all: { all: [], woman: [], man: [] },
    Hyperreal: { all: [], woman: [], man: [] },
    Anime: { all: [], woman: [], man: [] },
    Hyperanime: { all: [], woman: [], man: [] },
    Real: { all: [], woman: [], man: [] },
    'K-Pop': { all: [], woman: [], man: [] },
    Fur: { all: [], woman: [], man: [] },
  })

  const [userImages, setUserImages] = useState({})
  const [userLikedImages, setUserLikedImages] = useState({})
  const [usernames, setUsernames] = useState({})
  const [bios, setBios] = useState({})
  const [profiles, setProfiles] = useState({})

  const [userPlans, setUserPlans] = useState({})
  const [userGems, setUserGems] = useState({})
  const [hasUserImagesFetched, setHasUserImagesFetched] = useState({})
  const [hasUserLikedImagesFetched, setHasUserLikedImagesFetched] = useState({})

  const [hasUserPersonalImagesFetched, setHasUserPersonalImagesFetched] =
    useState(false)
  const [userPersonalImages, setUserPersonalImages] = useState([])

  const [activeButton, setActiveButton] = useState('Top')
  const [totalImageCount, setTotalImageCount] = useState(0)
  const [visibleImages, setVisibleImages] = useState(15)
  const [images, setImages] = useState([])
  const [activeButtonProfile, setActiveButtonProfile] = useState('Posts')
  const [format, setFormat] = useState('all')

  const [filteredImages, setFilteredImages] = useState([])

  // safeGetItem/safeSetItem, not raw localStorage: this provider wraps the entire
  // (chatAndCreateContext) group, and these reads run during render. On Safari with Private
  // Browsing or "Block All Cookies" the storage access itself throws SecurityError — a
  // `typeof window` check does not prevent it — which crashed the provider before any child
  // mounted and sent /chat, /generate, /explore and /image to the root error boundary.
  // A remembered Fur/Furtoon filter falls back to 'all': both were hidden 2026-10-06 and the
  // dropdown no longer has an option to show, or clear, that filter.
  const [model, setModel] = useState(() => {
    const saved = safeGetItem('exploreModel')
    return !saved || saved === 'Fur' || saved === 'Furtoon' ? 'all' : saved
  })

  const [gender, setGender] = useState(
    () => safeGetItem('exploreGender') || 'all',
  )

  // Discover's filters under the character_feed_filters flag (components/DiscoverFilters.tsx): straight characters in
  // every style, newest first, by default; each page of results cached by its filters' key.
  const [characterStyle, setCharacterStyle] = useState(() =>
    remembered(safeGetItem('exploreCharacterStyle'), CHARACTER_STYLES),
  )
  const [sexuality, setSexuality] = useState(() =>
    remembered(safeGetItem('exploreSexuality'), CHARACTER_SEXUALITIES),
  )
  const [characterSort, setCharacterSort] = useState(() =>
    remembered(safeGetItem('exploreCharacterSort'), CHARACTER_SORTS),
  )
  const [characterFeeds, setCharacterFeeds] = useState({})

  useEffect(() => {
    safeSetItem('exploreModel', model)
  }, [model])

  useEffect(() => {
    safeSetItem('exploreCharacterStyle', characterStyle)
    safeSetItem('exploreSexuality', sexuality)
    safeSetItem('exploreCharacterSort', characterSort)
  }, [characterStyle, sexuality, characterSort])

  useEffect(() => {
    safeSetItem('exploreGender', gender)
  }, [gender])

  return (
    <ChatImageContext.Provider
      value={{
        activeButton,
        setActiveButton,
        topImages,
        setTopImages,
        featuredImages,
        setFeaturedImages,
        model,
        setModel,
        userImages,
        setUserImages,
        userLikedImages,
        setUserLikedImages,
        hasUserImagesFetched,
        setHasUserImagesFetched,
        hasUserLikedImagesFetched,
        setHasUserLikedImagesFetched,
        usernames,
        setUsernames,
        userPlans,
        setUserPlans,
        userGems,
        setUserGems,
        totalImageCount,
        setTotalImageCount,
        hasUserPersonalImagesFetched,
        setHasUserPersonalImagesFetched,
        userPersonalImages,
        setUserPersonalImages,
        visibleImages,
        setVisibleImages,
        images,
        setImages,
        activeButtonProfile,
        setActiveButtonProfile,
        format,
        setFormat,
        bios,
        setBios,
        profiles,
        setProfiles,
        filteredImages,
        setFilteredImages,
        gender,
        setGender,
        characterStyle,
        setCharacterStyle,
        sexuality,
        setSexuality,
        characterSort,
        setCharacterSort,
        characterFeeds,
        setCharacterFeeds,
      }}
    >
      {children}
    </ChatImageContext.Provider>
  )
}
